export const formName = 'session-form';
export const newVersionId = 'new';
